import { Controller } from 'stimulus'
import LazyLoad from 'vanilla-lazyload'

export default class extends Controller {
  static targets = [
    'overviewFrame',
    'infoFormFrame',
    'cardNameInput',
    'cardNumberInput',
    'cardExpiryInput',
    'cardCvcInput',
    'cardSubmit',
    'cardForm',
    'cardErrors',
    'terms',
  ]

  connect() {
    this.setupFrameWatchers()

    this.stripe = Stripe(this.data.get('public-key'))
    this.stripeStyle = JSON.parse(this.data.get('stripe-style'))
    this.currency = this.data.get('currency')

    this.setupStripeElements()

    this.determineButtonValidity()
  }

  setupFrameWatchers() {
    // Watches the email, card and info forms for submission then updates the overview
    let watchTargets = [this.infoFormFrameTarget]
    this.formFramesObserver = new MutationObserver(
      this.framesMutated.bind(this)
    )
    watchTargets.forEach(function (item, index) {
      this.formFramesObserver.observe(item, { childList: true })
    }.bind(this))

    // Watches the overview frame for a reload then runs some initialisation
    this.overviewObserver = new MutationObserver(
      this.overviewMutated.bind(this)
    )
    this.overviewObserver.observe(this.overviewFrameTarget, { childList: true })
  }

  setupStripeElements() {
    this.cardNumber?.destroy()
    this.expiry?.destroy()
    this.cvc?.destroy()

    const elements = this.stripe.elements({
      fonts: [
        {
          cssSrc: 'https://use.typekit.net/wcy2cwh.css',
        },
      ],
    })
    this.cardNumber = elements.create('cardNumber', {
      style: this.stripeStyle,
      showIcon: true,
    })
    this.cardNumber.mount(this.cardNumberInputTarget)
    this.cardNumber.on('change', (event) => this.cardChanged(event))

    this.expiry = elements.create('cardExpiry', { style: this.stripeStyle })
    this.expiry.on('change', (event) => this.cardChanged(event))
    this.expiry.mount(this.cardExpiryInputTarget)

    this.cvc = elements.create('cardCvc', { style: this.stripeStyle })
    this.cvc.mount(this.cardCvcInputTarget)
    this.cvc.on('change', (event) => this.cardChanged(event))
  }

  cardChanged(event) {
    if (event.error) {
      this.cardErrorsTarget.textContent = event.error.message
    } else {
      this.cardErrorsTarget.textContent = ''
    }
  }

  submitUpdatedCard(event) {
    event.preventDefault()
    event.stopPropagation()

    this.disableCardSubmitButton()
    this.cardErrorsTarget.textContent = ''

    if (this.cardNameInputTarget.value.length == 0) {
      this.cardErrorsTarget.textContent = 'Please enter the name on your card'
      this.reEnableCardSubmitButton()
    } else if (!this.currency) {
      this.cardErrorsTarget.textContent =
        'Please select your preferred currency for your plan'
      this.reEnableCardSubmitButton()
    } else {
      this.stripe
        .createToken(this.cardNumber, { currency: this.currency })
        .then((result) => {
          if (result.error) {
            this.cardErrorsTarget.textContent = result.error.message
            this.reEnableCardSubmitButton()
          } else {
            this.addHiddenStripeTokenField(result.token)
          }
        })
    }
  }

  disableCardSubmitButton() {
    Rails.disableElement(this.cardSubmitTarget)
  }

  reEnableCardSubmitButton() {
    setTimeout(() => {
      Rails.enableElement(this.cardSubmitTarget)
    }, 300)
  }

  addHiddenStripeTokenField(token) {
    const hiddenInput = document.createElement('input')
    hiddenInput.setAttribute('type', 'hidden')
    hiddenInput.setAttribute('name', 'stripe_token')
    hiddenInput.setAttribute('value', token.id)

    this.cardFormTarget.appendChild(hiddenInput)
    this.cardFormTarget.submit()
  }

  framesMutated() {
    let src = this.overviewFrameTarget.getAttribute('src')
    this.overviewFrameTarget.setAttribute('src', src)
    this.initLazyLoad()
  }

  overviewMutated() {
    this.initLazyLoad()
  }

  initLazyLoad() {
    let lazyLoadOptions = { elements_selector: '.lazy' }
    window.pageLazyLoad = new LazyLoad(lazyLoadOptions)
  }

  determineButtonValidity() {
    var enabled = true
    if (this.hasTermsTarget) {
      var enabled = this.termsTarget.checked
    }

    this.cardSubmitTarget.disabled = !enabled
  }
}
